module.exports = __webpack_public_path__ + "img/icon_3.bfb0016b.png";